// inv/src/pages/solutions/early-stage-startup-founders/EarlyStageFoundersPage.jsx
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import SeoHead from '../../../seo/seoHead';
import FoundersHero from './blocks/FoundersHero';
import FoundersDiscoverSection from './blocks/FoundersDiscoverSection';
import FoundersResearchSection from './blocks/FoundersResearchSection';
import FoundersHeroWithDeals from './blocks/LastDealsSection';
import Testimonials from './blocks/Testimonials';
import SolutionDataExportSection from '../components/SolutionDataExportSection';
import { useInitialData } from '../../../components/data/DataContext';
import languages from '../../../locales/languages';

const EarlyStageFoundersPage = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const ssr = useInitialData() || {};

  const ssrLang = ssr.lang || null;
  const seo = ssr.seo || {};

  const firstSeg = location.pathname.split('/').filter(Boolean)[0];
  const urlLang = languages.some(l => l.code === firstSeg) ? firstSeg : 'en';
  const lng = ssrLang || urlLang || (i18n.language || 'en').split('-')[0];

  const fallbackTitle = t(
    'pageSolutions.EarlyStageFounders.t1',
    'Discover the right investors for your early-stage startup'
  );
  const fallbackDescription = t(
    'pageSolutions.EarlyStageFounders.t2',
    'Use Crino to map your ideal investors, analyse their latest deals, and focus your outreach on the funds most likely to back your vision.'
  );

  const {
    title = fallbackTitle,
    description = fallbackDescription,
    canonicalUrl,
    ogTitle,
    ogDescription,
    ogImage,
    ogUrl,
    ogType,
    twitterCard,
    alternates,
    jsonLd,
  } = seo;

  return (
    <>
      <SeoHead
        lang={lng}
        title={title}
        description={description}
        canonicalUrl={canonicalUrl}
        ogTitle={ogTitle}
        ogDescription={ogDescription}
        ogImage={ogImage}
        ogUrl={ogUrl}
        ogType={ogType}
        twitterCard={twitterCard}
        alternates={alternates}
        jsonLd={jsonLd}
      />

      <div className="mt-8">
        <FoundersHero />
        <FoundersDiscoverSection />
        <FoundersResearchSection />
        <SolutionDataExportSection />
        <FoundersHeroWithDeals />
        <Testimonials />
      </div>
    </>
  );
};

export default EarlyStageFoundersPage;
